import { type Pagination, type PaginationData, type UserList, createUserList } from 'models';
import { useInfiniteQuery } from 'query';
import type { ApiClientResponseError, DefaultResponseErrorDataObject } from 'common/services';
import { getOrganizationAdmins } from '../services';
import { getOrganizationAdminsInfiniteQueryKey } from './keys';

export type OrganizationAdminsFilter = {
  // TODO: This is not filter
  organizationId: string;
};

type P = {
  filter: OrganizationAdminsFilter;
  pagination: Omit<Pagination, 'position'>;
};

export const useOrganizationAdminsInfiniteQuery = ({ filter, pagination }: P) =>
  useInfiniteQuery<
    PaginationData<UserList>,
    string | undefined,
    ApiClientResponseError<DefaultResponseErrorDataObject>
  >({
    async queryFn({ pageParam: cursor }) {
      const { data } = await getOrganizationAdmins({
        config: {
          params: {
            cursor,
            limit: pagination.pageSize,
          },
        },
        routeParams: {
          id: filter.organizationId,
        },
      });

      return { data: data.data.map((admin) => createUserList(admin)), total: data.total };
    },
    initialPageParam: undefined,
    getNextPageParam(lastPage, allPages) {
      if (allPages.length * pagination.pageSize >= lastPage.total) {
        return undefined;
      }

      return lastPage.data.at(-1)?.id;
    },
    queryKey: getOrganizationAdminsInfiniteQueryKey({ filter, pagination }),
  });
